import { useCallback } from 'react';
import { useUserFetch } from '../api/fetch';

// 深夜時間帯(22:00〜5:00 JST)の視聴ブロック状態。判定はサーバの時計(JST)が正で、
// ブラウザの時計は使わない(端末の時刻設定に依存させない)。
export interface PlaybackWindow {
  blocked: boolean;
  start: string;
  end: string;
  // 次にブロック状態が切り替わるまでの秒数(ブロック機能が無効のときは null)。
  // 再生中にこの秒数が経過したら強制停止するのに使う。
  secondsUntilChange: number | null;
  message: string;
}

export const usePlaybackWindow = () => {
  const { get } = useUserFetch();

  const fetchPlaybackWindow = useCallback(async (): Promise<PlaybackWindow | null> => {
    try {
      return await get<PlaybackWindow>('/api/user/playback-window');
    } catch (error) {
      // 取得に失敗してもここでは再生を止めない(サーバ側の403ガードが最終防衛)。
      console.log('Failed to fetch playback window:', error);
      return null;
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { fetchPlaybackWindow };
};
